import { useQuery } from "@tanstack/react-query";
import { getAtkomstTeams } from "@coworker/app/src/hooks/API/core.service";
import { Team } from "../../shared/types/team";

/**
 * Fetches teams for a store using the /atkomst/teams/:storeId endpoint.
 * Unlike useTeamsByStore, this does NOT require the requesting user to exist
 * in the Fixa DB — it authenticates via Atkomst JWT instead.
 * Use this during the new user self-provisioning flow.
 */
export function useAtkomstTeamsByStore(storeId: string | null) {
  return useQuery<Team[]>({
    queryKey: ["atkomstTeams", storeId],
    queryFn: async () => {
      if (!storeId) return [];
      return await getAtkomstTeams(storeId);
    },
    enabled: !!storeId,
    staleTime: 15 * 60 * 1000,
    gcTime: 15 * 60 * 1000, // ponytail: keep in sync with staleTime
    refetchOnWindowFocus: false,
  });
}
